import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/PageHeader/PageHeader';
import useRssFeed from '../../hooks/useRssFeed';

import { ReactComponent as CamelIcon } from '../../assets/site-assets/events/icon.svg';
import EventsBg from '../../assets/site-assets/events/bg.png';
import Ent1     from '../../assets/site-assets/events/Entertainment-1.png';
import Ent2     from '../../assets/site-assets/events/Entertainment-2.png';
import Ent3     from '../../assets/site-assets/events/Entertainment-3.png';
import Ent4     from '../../assets/site-assets/events/Entertainment-4.png';
import './EventsPage.scss';

const destinationImgs = [Ent1, Ent2, Ent3, Ent4];

const EventCard = ({ title, link, image }) => (
  <a
    href={link || '/'}
    className="events-grid__card"
    style={image ? { backgroundImage: `url(${image})` } : undefined}
    target="_blank"
    rel="noopener noreferrer"
  >
    <div className="events-grid__overlay" />
    <div className="events-grid__body">
      <h3 className="events-grid__title">{title}</h3>
    </div>
  </a>
);

const EventsPage = () => {
  const { t, i18n } = useTranslation();
  const { items, loading, error } = useRssFeed(i18n.language, 9);
  const events = items.slice(0, 9);

  return (
    <div className="events-page">

      <PageHeader
        bgImage={EventsBg}
        titleNode={
          <>{t('events.pageTitlePre')}{' '}
            <span className="events-page__title-highlight">{t('events.pageTitleHighlight')}</span>{' '}
            {t('events.pageTitlePost')}
          </>
        }
        subtitle={t('events.subtitle')}
      />

      {/* ── The Sharjah Scene — RSS event cards ── */}
      <section className="events-grid">
        <CamelIcon className="events-grid__camel" aria-hidden="true" />
        <div className="events-container">
          {loading ? (
            <div className="events-grid__skeleton-grid" aria-hidden="true">
              {Array.from({ length: 9 }).map((_, i) => (
                <div key={i} className="events-grid__skeleton" />
              ))}
            </div>
          ) : error || events.length === 0 ? (
            <div className="events-grid__loading">
              {t('events.errorPrefix')}{' '}
              <a href="https://sharjahevents.ae" target="_blank" rel="noopener noreferrer" style={{ color: '#F27C16' }}>
                {t('events.errorLinkText')}
              </a>{' '}
              {t('events.errorSuffix')}
            </div>
          ) : (
            <div className="events-grid__wrap">
              {events.map((ev, i) => (
                <EventCard key={ev.link || i} {...ev} />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ── Entertainment Destinations in Sharjah ── */}
      <section className="events-destinations">
        <div className="events-container">
          <h2 className="events-destinations__heading">
            {t('events.destinations.titleLine1')}<br />
            {t('events.destinations.titleLine2')}{' '}
            <span>{t('events.destinations.titleHighlight')}</span>
          </h2>
        </div>

        <div className="events-container">
          <div className="events-destinations__rows">
            {destinationImgs.map((image, i) => {
              const reversed = i % 2 !== 0;
              return (
                <div key={i} className={`events-dest__row${reversed ? ' events-dest__row--reversed' : ''}`}>
                  <div className="events-dest__text">
                    <h3 className="events-dest__title">{t(`events.destinations.items.${i}.title`)}</h3>
                    <p className="events-dest__body">{t(`events.destinations.items.${i}.body`)}</p>
                  </div>
                  <div
                    className="events-dest__image"
                    style={{ backgroundImage: `url(${image})` }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>

    </div>
  );
};

export default EventsPage;
